import { render, staticRenderFns } from "./AppScoresNBASeries.vue?vue&type=template&id=65768abb&"
import script from "./AppScoresNBASeries.vue?vue&type=script&lang=js&"
export * from "./AppScoresNBASeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports